<template>
  <v-row no-gutters>
    <!-- Left column -->
    <v-col
      cols="12"
      md="6"
      class="d-flex align-start justify-center justify-lg-end pa-6 stripe-scroller-hidden"
    >
      <div style="width: 100%; max-width: 580px">
        <StripeSkeleton />
      </div>
    </v-col>

    <!-- Right column  -->
    <v-col
      cols="12"
      md="6"
      class="d-none d-md-flex align-start justify-center justify-lg-start pa-6"
      style="
        position: sticky;
        background-color: #fafafa;
        border-left: 1px solid #cbc7c7;
      "
    >
      <div style="width: 100%; max-width: 480px">
        <CheckoutProductSkeleton />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CheckoutProductSkeleton from "@/components/crane/cart-product/CheckoutProductSkeleton.vue";
import StripeSkeleton from "@/components/crane/payment/StripeSkeleton.vue";
export default {
  name: "CheckoutPageSkeleton",
  data() {
    return {
      loading: true,
      sameAsShipping: true,
    };
  },
  components: {
    CheckoutProductSkeleton,
    StripeSkeleton,
  },
  mounted() {
    setTimeout(() => {
      //  this.loading = false
    }, 3000);
  },
};
</script>


<style lang="scss">
.cart-product-list-expansion .v-expansion-panel-text__wrapper {
  padding: 0 0px 0px !important;
}

.active-panel-edited .v-expansion-panel-title__overlay {
  background-color: transparent !important;
}

body:has(.stripe-scroller-hidden) {
  overflow: hidden;
}
</style>
